import { Badge } from "@/components/ui/badge";
import { ShieldCheck } from "lucide-react";

interface JuniorBadgeProps {
  className?: string;
}

export default function JuniorBadge({ className }: JuniorBadgeProps) {
  return (
    <Badge variant="secondary" className={`gap-1 text-xs ${className ?? ""}`}>
      <ShieldCheck className="h-3 w-3" />
      Under 18
    </Badge>
  );
}
